export const reportToSegment = (type, name, properties = {}, options = {}) => {
  if (type === 'track') {
    console.log(name, properties, options)
    window.analytics.track(name, properties, options)
  }

  if (type === 'page') {
    window.analytics.page(name, properties, options)
  }

  if (type === 'identify') {
    window.analytics.identify(name, properties, options)
  }
};
